import React, { useState, useEffect } from "react";
import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import ApproveCompanyTransaction from "./ApproveCompanyTransaction";

function AuthCompanyTransaction() {
  const [group, setGroup] = useState([]);
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
  const [status, setstatus] = useState(false);
  const [authDetailId, setAuthDetailId] = useState([]);
  const [transHeadId, setTransHeadId] = useState([]);
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  useEffect(() => {
    const getGroup = async () => {
      setloading(true);
      const response = await handleGetRequest(
        "zbizgateway/nonFin/companyAuth/fetchAllPendingAuthTransactions"
      );
      setGroup(response?.data);
      setloading(false);
    };
    getGroup();
  }, []);

  const onHide = (name) => {
    setDisplaySubDetailsModal(false);
  };

  const handleAddNewSubDetails = (e, btnStatus) => {
    e.preventDefault();
    setstatus(btnStatus);
    setDisplaySubDetailsModal(true);
  };

  const onRowSelect = (event) => {
    setAuthDetailId(event.data.authDetailId);
    setTransHeadId(event.data.transHeadId);
  };

  return (
    <>
      <Dialog
        visible={displaySubDetailsModal}
        style={{ width: "50vw" }}
        onHide={() => setDisplaySubDetailsModal(false)}
      >
        <ApproveCompanyTransaction
          status={status}
          authDetailId={authDetailId}
          transHeadId={transHeadId}
          onHide={onHide}
        />
      </Dialog>
      <div className="card p-datatable-sm">
        <DataTable
          header="Authorize Company Transaction"
          value={group}
          loading={loading}
          selection={selectedCustomers}
          onSelectionChange={(e) => setSelectedCustomers(e.value)}
          onRowSelect={onRowSelect}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          emptyMessage="No data found."
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3em" }}
          ></Column>
          <Column filter field="authComments" header="Authorization Comments" />
          <Column filter field="authDate" header="Authorization Date" />
          <Column filter field="companyName" header="Company Name" />
          <Column filter field="benName" header="Beneficiary Name" />
          <Column
            filter
            field={(item) => (
              <b>
                {item?.transAmount &&
                  item?.transAmount.toLocaleString("en-PK").split(".")[0]}
              </b>
            )}
            header="Trans Amount"
          />
          <Column filter field="transDate" header="Trans Date" />
          <Column filter field="docNo" header="Document No" />
          <Column filter field="masterProductName" header="Product Name" />
        </DataTable>
      </div>
      <div className="Down__Btn">
        <Button
          label="Reject"
          onClick={(e) => handleAddNewSubDetails(e, "R")}
          className="Btn__Transparent"
        />
        <Button
          disabled={loading}
          onClick={(e) => handleAddNewSubDetails(e, "A")}
          label="Approve"
          className="Btn__Dark"
        />
      </div>
    </>
  );
}

export default AuthCompanyTransaction;
